import {
  IdRequest,
  LoadState,
  RemoteResult,
  ReservierungPending,
} from "mangdto"
import BaseLogic from "../base_logic"
import vuexStore from "@/store"
import Poster from "@/util/poster"
import RestPaths from "@/util/rest_paths"
import router from "@/router"
import RouteNames from "@/util/route_names"
import Formatter from "../formatter"

export default class BestaetigenReservierungNeuLogic extends BaseLogic {
  reservierung: ReservierungPending = null
  // reservierungAufgeben: boolean = false
  // bestaetigenWorking: boolean = false
  // bestaetigenError: boolean = false
  bestaetigenLoadState: LoadState = LoadState.Idle

  init() {
    this.mainLogic.reservierungPendingListeners.push(() => {
      this.reservierung = this.mainLogic.reservierungPending
    })
    this.reservierung = this.mainLogic.reservierungPending
  }

  get datumUhrzeit(): string {
    return Formatter.formatiereTimeSpan(
      this.reservierung.zeitVon,
      this.reservierung.zeitBis,
    )
    //   Formatter.formatiereDatumUhrzeit(this.reservierung.zeitVon) +
    //   " - " +
    //   Formatter.formatiereDatumUhrzeit(this.reservierung.zeitBis)
    // )
  }

  get personen(): string {
    return this.reservierung.personen.toString()
  }

  get kundeBezeichnung(): string {
    return (
      this.reservierung.kundeVorname + " " + this.reservierung.kundeNachname
    )
  }

  reservierungBestaetigen() {
    this.bestaetigenLoadState = LoadState.Loading

    var request = new IdRequest()
    request.id = vuexStore.state.user.identifier

    Poster.postMember<RemoteResult<string>>(
      RestPaths.reservierungenPendingBestaetigen,
      request,
    )
      .then((response) => {
        if (response.data.success) {
          this.bestaetigenLoadState = LoadState.Completed

          router.push({ name: RouteNames.NEU.RESERVIERUNG_BESTAETIGT })
        } else {
          this.bestaetigenLoadState = LoadState.Completed
        }
      })
      .catch(() => {
        this.bestaetigenLoadState = LoadState.Completed
      })
  }
}
